if (customElements.get('details-accordion') === undefined) {
  class DetailsAccordion extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.body = Array.prototype.slice.call(this.details.children).find(element => element != this.summary);
      this.active = false;

      this.summary.addEventListener('click', this.toggleBody.bind(this), false);
    }

    toggleBody() {
      event.preventDefault();
      this.details.style.overflow = 'hidden';

      if (!this.active && !this.details.open) {
        this.open();
      } else if (!this.active && this.details.open) {
        this.close();
      }
    }

    open() {
      this.active = true;
      this.details.open = true;
      this.body.style.height = `${this.body.offsetHeight}px`;

      this.animation = this.body.animate({
        height: [0, this.body.offsetHeight] }, { duration: 400, easing: 'ease-out'
      });

      this.animation.onfinish = () => {
        this.active = false;
      };
    }

    close() {
      this.active = true;

      this.animation = this.body.animate({
        height: [this.body.offsetHeight, 0] }, { duration: 400, easing: 'ease-out'
      });

      this.animation.onfinish = () => {
        this.details.open = false;
        this.active = false;
      };
    }
  }

  customElements.define('details-accordion', DetailsAccordion);
}
